import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {DateHelperService} from './dateHelper.service';

@Injectable()
export class TicklerService {
    private ticklerExpectedDateCutoff = null;

    constructor(private dateHelperService: DateHelperService) {
    }

    /*

    INITIAL UPCOMING

 */
    addInitialUpcomingResult(initial, config, ticklerDataPoint, ticklerConfig) {
        if ((initial)
            && (initial.type < 0)
            && (initial.owns !== false)
            && moment(initial.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
            && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(initial.date))) {
            const result: any = {};
            result.dueDate = initial.date;
            result.orgUnitName = ticklerDataPoint.ouName;
            result.description = ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName +
                ' Start Date was ' + moment(ticklerDataPoint.placementStartDate).format('MMMM DD, YYYY') + '.  Client will need Initial ' + ticklerConfig.itemType + ' Assessment.';
            result.clientId = ticklerDataPoint.clientId;
            result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
            config.result.push(result);
            config.count++;
        }
    }

    processInitialUpcoming(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let initial;
            initial = this.getInitial(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addInitialUpcomingResult(initial, config, ticklerDataPoint, ticklerConfig);
        });
    }

    /*

        INITIAL OVERDUE

    */
    addInitialOverdueResult(initial, config, ticklerDataPoint, ticklerConfig) {
        if ((initial)
            && (initial.type > 0)
            && (initial.owns !== false)
            && moment(initial.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
            && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(initial.date))) {
            const result: any = {};
            result.dueDate = initial.date;
            result.orgUnitName = ticklerDataPoint.ouName;
            result.description = ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName +
                ' Start Date was ' + ticklerDataPoint.placementStartDate + '.  Client needs Initial ' + ticklerConfig.itemType + ' Assessment.';
            result.clientId = ticklerDataPoint.clientId;
            result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
            config.result.push(result);
            config.count++;
        }
    }

    processInitialOverdue(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let initial;
            initial = this.getInitial(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addInitialOverdueResult(initial, config, ticklerDataPoint, ticklerConfig);
        });
    }

    /*

        UPDATE UPCOMING

     */

    addUpdateUpcomingResult(updates, config, ticklerDataPoint, ticklerConfig) {

        updates.forEach((update) => {
            if ((update)
                && (update.type < 0)
                && (update.owns !== false)
                && (update.discharge === false)
                && moment(update.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
                && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(update.date))) {
                const result: any = {};
                result.dueDate = update.date;
                result.orgUnitName = ticklerDataPoint.ouName;
                result.description = ' Update ' + ticklerConfig.itemType + ' assessment is upcoming for ' + ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName;
                result.clientId = ticklerDataPoint.clientId;
                result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
                config.result.push(result);
                config.count++;
            }
        });
    }

    processUpdateUpcoming(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let updates;
            updates = this.getUpdates(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.ouReassessmentFrequency
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.placementEndDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addUpdateUpcomingResult(updates, config, ticklerDataPoint, ticklerConfig);
        });
    }

    /*

        UPDATE OVERDUE

     */
    addUpdateOverdueResult(updates, config, ticklerDataPoint, ticklerConfig) {

        updates.forEach((update) => {
            if ((update)
                && (update.type > 0)
                && (update.owns !== false)
                && (update.discharge === false)
                && moment(update.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
                && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(update.date))) {
                const result: any = {};
                result.dueDate = update.date;
                result.orgUnitName = ticklerDataPoint.ouName;
                result.description = ' Update ' + ticklerConfig.itemType + ' assessment is overdue for ' + ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName;
                result.clientId = ticklerDataPoint.clientId;
                result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
                config.result.push(result);
                config.count++;
            }
        });
    }

    processUpdateOverdue(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let updates;
            updates = this.getUpdates(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.ouReassessmentFrequency
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.placementEndDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addUpdateOverdueResult(updates, config, ticklerDataPoint, ticklerConfig);
        });
    }

    /*

        DISCHARGE UPCOMING

     */
    addDischargeUpcomingResult(updates, config, ticklerDataPoint, ticklerConfig) {

        updates.forEach((update) => {
            if (update
                && (update.type < 0)
                && (update.discharge === true)
                && (update.owns !== false)
                && moment(update.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
                && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(update.date))
            ) {
                const result: any = {};
                result.dueDate = update.date;
                result.orgUnitName = ticklerDataPoint.ouName;
                result.description = 'Discharge ' + ticklerConfig.itemType + ' assessment is upcoming for ' + ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName;
                ;
                result.clientId = ticklerDataPoint.clientId;
                result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
                config.result.push(result);
                config.count++;
            }
        });
    }

    processDischargeUpcoming(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let updates;
            updates = this.getUpdates(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.ouReassessmentFrequency
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.placementEndDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addDischargeUpcomingResult(updates, config, ticklerDataPoint, ticklerConfig);
        });
    }

    /*

        DISCHARGE OVERDUE

     */
    addDischargeOverdueResult(updates, config, ticklerDataPoint, ticklerConfig) {

        updates.forEach((update) => {
            if (update
                && (update.type > 0)
                && (update.discharge === true)
                && (update.owns !== false)
                && moment(update.date).add(ticklerConfig.pastWindowMonths, 'M').isAfter(moment())
                && moment().add(ticklerConfig.futureWindowMonths, 'M').isAfter(moment(update.date))) {
                const result: any = {};
                result.dueDate = update.date;
                result.orgUnitName = ticklerDataPoint.ouName;
                result.description = 'Discharge ' + ticklerConfig.itemType + ' assessment is overdue for ' + ticklerDataPoint.clientFirstName + ' ' + ticklerDataPoint.clientLastName;
                result.clientId = ticklerDataPoint.clientId;
                result.userName = ticklerDataPoint.userFirstName + ' ' + ticklerDataPoint.userLastName;
                config.result.push(result);
                config.count++;
            }
        });
    }

    processDischargeOverdue(config, ticklerConfig, ticklerDataPoints) {

        ticklerDataPoints.forEach((ticklerDataPoint) => {
            let updates;
            updates = this.getUpdates(ticklerDataPoint.assessmentInfo
                , ticklerDataPoint.episodeStartDateObj
                , ticklerDataPoint.episodeEndDateObj
                , ticklerDataPoint.ouReassessmentFrequency
                , ticklerDataPoint.placementStartDateObj
                , ticklerDataPoint.placementEndDateObj
                , ticklerDataPoint.clientDobObj
                , this.resolveGenericConfig(ticklerDataPoint, ticklerConfig)
                , this.resolveInstrumentTicklerInstrumentTypes(ticklerConfig)
                , this.resolveAgeRestrictions(ticklerConfig)
                , false
            );
            this.addDischargeOverdueResult(updates, config, ticklerDataPoint, ticklerConfig);
        });
    }

    resolveGenericConfig(ticklerDataPoint, ticklerConfig) {
        if (ticklerDataPoint == null) {
            return {};
        }

        const ouCode = ticklerDataPoint.ouCode;
        const ticklerRules = ticklerConfig.ticklerRules;
        if (ticklerRules.ous[ouCode]) {
            return ticklerRules.ous[ouCode];
        } else {
            return ticklerRules.defaultConfig;
        }
    }

    hydrateTicklerConfig(config, ticklerConfig, ticklerDataPoints) {
        // config.result = [];
        // config.count = 0;
        switch (config.toDoType) {
            case ('TICKLER_INITIAL_UPCOMING'):
                this.processInitialUpcoming(config, ticklerConfig, ticklerDataPoints);
                break;
            case ('TICKLER_INITIAL_OVERDUE'):
                this.processInitialOverdue(config, ticklerConfig, ticklerDataPoints);
                break;
            case('TICKLER_UPDATE_UPCOMING'):
                this.processUpdateUpcoming(config, ticklerConfig, ticklerDataPoints);
                break;
            case('TICKLER_UPDATE_OVERDUE'):
                this.processUpdateOverdue(config, ticklerConfig, ticklerDataPoints);
                break;
            case('TICKLER_DISCHARGE_UPCOMING'):
                this.processDischargeUpcoming(config, ticklerConfig, ticklerDataPoints);
                break;
            case('TICKLER_DISCHARGE_OVERDUE'):
                this.processDischargeOverdue(config, ticklerConfig, ticklerDataPoints);
                break;
            default:
                break;
        }
    }

    resolveInstrumentTicklerInstrumentTypes(ticklerConfig) {
        return ticklerConfig.instrumentTypes;
    };

    resolveAgeRestrictions(ticklerConfig) {
        return ticklerConfig.ticklerRules.ageRestrictions;
    }

    getInitial(assmtStr, epOpening, epClosing, plOpening, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly) {
        return this.getInitialCommon(assmtStr, epOpening, epClosing, plOpening, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly);
    }

    getUpdates(assmtStr, epOpening, epClosing, reassessmentFrequency, plOpening, plClosing, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly) {
        return this.getUpdatesCommon(assmtStr, epOpening, epClosing, reassessmentFrequency, plOpening, plClosing, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly);
    }

    dateOutsideInstrumentsRange(assessmentDate, clientDob, instrumentsArray, ageRestrictions) {

        if (clientDob == null || assessmentDate == null) {
            return true;
        }

        const monthsDifference = this.dateHelperService.monthsBetween(clientDob, assessmentDate);

        // let instrumentsArray = reportContext.getGloballetiable("ticklerEpisodeInstrumentTypes");
        // let ageRestrictions = reportContext.getGloballetiable("ticklerEpisodeConfig").ageRestrictions;

        if (ageRestrictions != null) {
            let result = true;
            for (const key of ageRestrictions) {
                if (instrumentsArray.indexOf('' + key) >= 0) {
                    const obj = ageRestrictions[key];
                    if ((obj.lower == null || monthsDifference >= obj.lower) && (obj.upper == null || monthsDifference <= obj.upper)) {
                        result = false;
                    }
                }
            }
            return result;
        } else {
            return false;
        }
    }

    getInitialCommon(assmtStr, epOpening, epClosing, plOpening, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly) {
        let initialDate = null;
        let updateExists = false;
        let completionCode = '';

        if (assmtStr != null) {
            const entries = assmtStr.split(',');
            let startIdx;
            let endIdx;
            let increment;
            let backwards;
            if (config.initialLoopDirectionBackwards === true) {
                backwards = true;
                startIdx = entries.length - 1;
                endIdx = 0;
                increment = -1;
            } else {
                backwards = false;
                startIdx = 0;
                endIdx = entries.length - 1;
                increment = 1;
            }

            // Set up a letiable direction loop depending on the config above.
            let initialIdx = -1;
            if (!config.useSequence || config.useSequence === false) {
                // Set up a letiable direction loop depending on the config above.
                for (let i = startIdx; (backwards && i >= endIdx) || (!backwards && i <= endIdx); i += increment) {
                    if (entries[i] != null) {
                        const parts = entries[i].split('|');
                        if (parts.length === 3 && (config.initialReasons.indexOf(parts[0]) >= 0)) {
                            // Make sure we only include Initial if before epClosing. We don't include initials that are in
                            // the epClosing buffer (between epClosing and end)
                            if (epClosing == null || this.dateHelperService.parseDbDate(parts[1]) <= epClosing) {
                                initialDate = this.dateHelperService.parseDbDate(parts[1]);
                                initialIdx = i;
                                if (parts[2] != null && parts[2] !== '') {
                                    completionCode = parts[2].substring(0, 2);
                                }
                            }
                        }
                    }
                }
            } else {
                // Since using sequence rather than ReasonForAssessment, take the first entry as the Initial candidate.
                const parts = entries[0].split('|');
                if (parts.length === 3) {
                    // Make sure we only include Initial if before epClosing. We don't include initials that are in
                    // the epClosing buffer (between epClosing and end)
                    if (epClosing == null || this.dateHelperService.parseDbDate(parts[1]) <= epClosing) {
                        initialIdx = 0;
                        initialDate = this.dateHelperService.parseDbDate(parts[1]);
                        if (parts[2] != null && parts[2] !== '') {
                            completionCode = parts[2].substring(0, 2);
                        }
                    }
                }
            }

            // Do this check to see if there are any assessments completed after the assessment
            // found as the initial.  Should still work if initialIdx is -1
            if (entries.length - 1 > initialIdx) {
                updateExists = true;
            }
        }

        let initialType = 0;

        if ((initialDate == null)
            && (config.shortEpisodeIgnoreDays < 0
                || epOpening == null
                || epClosing == null
                || this.dateHelperService.daysBetween(epOpening, epClosing) > config.shortEpisodeIgnoreDays)
        ) {
            initialDate = new Date(epOpening);
            initialDate.setDate(initialDate.getDate() + config.initialDueDateOffset);
            const todaysDate = new Date();
            const todaysDateWithGracePeriod = new Date(todaysDate);
            todaysDateWithGracePeriod.setDate(todaysDateWithGracePeriod.getDate() + config.latenessCutoffDays);

            if ((this.ticklerExpectedDateCutoff != null) && (initialDate < this.ticklerExpectedDateCutoff)) {
                initialDate = null;
            } else if (this.dateOutsideInstrumentsRange(initialDate, clientDob, instrumentsArray, ageRestrictions)) {
                initialDate = null;
            } else {
                const distance = this.dateHelperService.daysBetween(initialDate, todaysDate);
                if (initialDate > todaysDate) {
                    if (distance < config.initialUpcomingRangeCutoff) {
                        initialType = -2;
                    } else {
                        initialType = -1;
                    }
                } else {
                    if (distance < config.initialOverdueRangeCutoff1) {
                        // Grace Period.
                        initialType = -1;
                    } else if (distance < config.initialOverdueRangeCutoff2) {
                        // Overdue
                        initialType = 1;
                    } else {
                        // Long Overdue
                        if (config.longOverdueModel === true) {
                            // SanBernardino Model -- Possibility of LongOverdue Type1 vs. longoverdue w/recent done.
                            if (updateExists) {
                                initialType = 3;
                            } else {
                                initialType = 2;
                            }
                        } else {
                            // LongOverdue Type2
                            initialType = 5;
                        }
                    }
                }
            }
        } else {
            if (epClosing != null && initialDate > epClosing) {
                initialType = 4;
            }
        }

        // Particular logic:  If an update exists then check to see if the date is before the placement open
        // and indicate that ownership is not for this placement is so.
        //
        // The real point here is that if no Update exists, then everybody owns the Initial not having been done,
        // regardless of where the due date for it falls.
        let owns = true;
        if (updateExists) {
            if (initialDate != null && initialDate < plOpening) {
                owns = false;
            }
        }

        // Only return an actual (type 0) if the inventoryOnly is true.
        if (!inventoryOnly || initialType === 0) {
            return {date: initialDate, type: initialType, completionCode: completionCode, owns: owns};
        } else {
            return {date: null, type: null, completionCode: null, owns: null};
        }
    }

    getUpdatesCommon(assmtStr, epOpening, epClosing, reassessmentFrequency, plOpening, plClosing, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly) {
        let ret = [];
        const temp = [];

        // Load the actual dates if present
        if (assmtStr != null) {
            const entries = assmtStr.split(',');

            for (let i = 0; i < entries.length; i++) {
                if (entries[i] != null) {
                    const parts = entries[i].split('|');
                    if (!config.useSequence || config.useSequence === false) {
                        if (parts.length === 3 && config.initialReasons.indexOf(parts[0]) < 0) {
                            // Do not include discharges/updates that are before epOpening, i.e. discharges/updates in the buffer before epOpening
                            if (!((config.dischargeReasons.indexOf(parts[0]) >= 0 || config.updateReasons.indexOf(parts[0]) >= 0) && this.dateHelperService.parseDbDate(parts[1]) < epOpening)) {
                                const parsedDbDate = this.dateHelperService.parseDbDate(parts[1]);
                                temp.push({
                                    type: 'actual'
                                    ,
                                    date: parsedDbDate
                                    ,
                                    completionCode: parts[2] != null && parts[2] !== '' ? parts[2].substring(0, 2) : ''
                                    ,
                                    discharge: config.dischargeReasons.indexOf(parts[0]) >= 0
                                    ,
                                    owns: (parsedDbDate >= plOpening && (plClosing == null || parsedDbDate <= plClosing)) ? true : false
                                });
                            }
                        }
                    } else {
                        // If using sequencing, assume that the updates are every assessment other
                        // that the first, which would be taken to be the Initial.
                        if (i !== 0) {
                            const parsedDbDate = this.dateHelperService.parseDbDate(parts[1]);
                            temp.push({
                                type: 'actual'
                                ,
                                date: parsedDbDate
                                ,
                                completionCode: parts[2] != null && parts[2] !== '' ? parts[2].substring(0, 2) : ''
                                ,
                                discharge: false
                                ,
                                owns: (parsedDbDate >= plOpening && (plClosing == null || parsedDbDate <= plClosing)) ? true : false
                            });
                        }
                    }
                }
            }
        }

        // Grab a copy of the Initial assessment.  Although one may not be found...
        const initialAssessment = this.getInitialCommon(assmtStr, epOpening, epClosing, plOpening, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly);
        // Load the expected dates based on the configuration.
        let expected;
        switch (config.expectedIntervalStrategy) {
            case 1:
                expected = this.getFixedAssessmentsIntervalsCommon1(epOpening, epClosing, reassessmentFrequency, temp, initialAssessment, config);
                break;
            case 2:
                expected = this.getFixedAssessmentsIntervalsCommon2(epOpening, epClosing, reassessmentFrequency, temp, initialAssessment, config);
                break;
            case 3:
                expected = this.getFixedAssessmentsIntervalsCommon3(epOpening, epClosing, reassessmentFrequency, temp, initialAssessment, config);
                break;
            case 4:
                expected = [];
                break;
            case 0:
            default:
                expected = this.getRollingAssessmentsIntervalsCommon(epOpening, epClosing, reassessmentFrequency, temp, initialAssessment, config);
                break;
        }
        for (let i = 0; i < expected.length; i++) {
            temp.push({
                type: 'expected'
                ,
                date: expected[i].date
                ,
                completionCode: ''
                ,
                discharge: expected[i].discharge
                ,
                owns: (expected[i].date >= plOpening && (plClosing == null || expected[i].date <= plClosing)) ? true : false
            });
        }

        // Order the dates
        temp.sort(function (a, b) {
            return a.date.getTime() - b.date.getTime();
        });

        // Find which expected dates are matched by the actual assessments and remove them
        const toDrop = [];
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].type === 'actual') {
                if (i > 0 && temp[i - 1].type === 'expected' && this.dateHelperService.daysBetween(temp[i - 1].date, temp[i].date) <= config.dropExpectedsAfterCutoff) {
                    if (toDrop.indexOf(i - 1) < 0) {
                        toDrop.push(i - 1);
                    }
                }

                if (i < temp.length - 1 && temp[i + 1].type === 'expected' && this.dateHelperService.daysBetween(temp[i].date, temp[i + 1].date) <= config.dropExpectedsBeforeCutoff) {
                    if (toDrop.indexOf(i + 1) < 0) {
                        toDrop.push(i + 1);
                    }
                }
            }
        }

        toDrop.sort(function (a, b) {
            return a - b;
        });
        let count = 0;
        for (let i = 0; i < toDrop.length; i++) {
            temp.splice(toDrop[i] - count, 1);
            count++;
        }

        // Try to figure out if a discharge assessment is needed to add to the report.
        if (epClosing != null) {
            // Only if there are at least 30 days between epOpening and epClosing.
            // Otherwise, it's a short episode, and so don't consider.
            if (this.dateHelperService.daysBetween(epOpening, epClosing) > config.shortEpisodeIgnoreDays) {
                // See if there are 30 days between when the last assessment was done/exp,
                // and when the discharge would be expected.

                if ((temp.length > 0) || ((initialAssessment != null) && (initialAssessment.date != null))) {
                    // Figure out the latest of two dates, given that either could be null.
                    let lastAssmt;
                    // First check the case where both are not null.
                    if ((temp.length > 0) && (initialAssessment != null)) {
                        const dt1 = temp[temp.length - 1].date;
                        const dt2 = initialAssessment.date;
                        lastAssmt = ((dt1 < dt2) ? dt2 : dt1);
                    } else if (temp.length > 0) { // Next see if temp is not empty.
                        lastAssmt = temp[temp.length - 1].date;
                    } else { // Finally assume that initialAssessment is not null.
                        lastAssmt = initialAssessment.date;
                    }
                    const epClosingDate = new Date(epClosing);
                    if ((epClosingDate > lastAssmt) && (this.dateHelperService.daysBetween(lastAssmt, epClosingDate) > config.dischargeNeededInterval)) {
                        const pushDate = new Date(epClosing);
                        pushDate.setDate(epClosing.getDate() + config.dischargeDueDateInterval);
                        temp.push({
                            type: 'expected'
                            ,
                            date: pushDate
                            ,
                            completionCode: ''
                            ,
                            discharge: true
                            ,
                            owns: (pushDate >= plOpening && (plClosing == null || pushDate <= plClosing)) ? true : false
                        });
                    }
                } else {
                    const pushDate = new Date(epClosing);
                    pushDate.setDate(pushDate.getDate() + config.dischargeDueDateInterval);
                    temp.push({
                        type: 'expected'
                        , date: pushDate
                        , completionCode: ''
                        , discharge: true
                        , owns: (pushDate >= plOpening && (plClosing == null || pushDate <= plClosing)) ? true : false
                    });
                }
            }
        }

        // Compute the type for the dates
        // let initial = getInitialCommon(assmtStr, epOpening, epClosing, plOpening, clientDob, config, instrumentsArray, ageRestrictions, inventoryOnly);
        const today = new Date();

        let numPushed = 0;
        for (let i = 0; i < temp.length; i++) {
            // Actual date
            if (temp[i].type === 'actual') {
                ret.push({
                    date: temp[i].date,
                    type: 0,
                    completionCode: temp[i].completionCode,
                    discharge: temp[i].discharge,
                    owns: temp[i].owns
                });
                numPushed++;
                // Go back and change the previous overdue assessments of type 2 (if any) to type 3
                for (let k = 0; k < (numPushed - 1); k++) {
                    if (ret[k].type === 2) {
                        ret[k].type = 3;
                    }
                }
            } else { // Expected date
                const expectedDate = temp[i].date;
                const discharge = temp[i].discharge;
                const owns = temp[i].owns;

                if (!this.dateOutsideInstrumentsRange(expectedDate, clientDob, instrumentsArray, ageRestrictions)) {
                    // In the future
                    if (expectedDate > today) {
                        if (this.dateHelperService.daysBetween(today, expectedDate) < config.updateUpcomingRangeCutoff) {
                            ret.push({
                                date: expectedDate,
                                type: -2,
                                completionCode: '',
                                discharge: discharge,
                                owns: owns
                            });
                            numPushed++;
                        } else {
                            ret.push({
                                date: expectedDate,
                                type: -1,
                                completionCode: '',
                                discharge: discharge,
                                owns: owns
                            });
                            numPushed++;
                        }
                    } else { // In the past
                        if ((this.ticklerExpectedDateCutoff == null) || (expectedDate >= this.ticklerExpectedDateCutoff)) {
                            const distance = this.dateHelperService.daysBetween(expectedDate, today);
                            if (reassessmentFrequency >= config.longReassessmentFrequencyCutoff) {
                                if (distance < config.longReassessmentUpcomingRangeCutoff) {
                                    ret.push({
                                        date: expectedDate
                                        , type: 1
                                        , completionCode: ''
                                        , discharge: discharge
                                        , owns: owns
                                    });
                                    numPushed++;
                                } else {
                                    ret.push({
                                        date: expectedDate
                                        , type: config.longOverdueModel ? 2 : 5
                                        , completionCode: ''
                                        , discharge: discharge
                                        , owns: owns
                                    });
                                    numPushed++;
                                }
                            } else {
                                if (distance < config.shortReassessmentUpcomingRangeCutoff) {
                                    ret.push({
                                        date: expectedDate
                                        , type: 1
                                        , completionCode: ''
                                        , discharge: discharge
                                        , owns: owns
                                    });
                                    numPushed++;
                                } else {
                                    ret.push({
                                        date: expectedDate
                                        , type: config.longOverdueModel ? 2 : 5
                                        , completionCode: ''
                                        , discharge: discharge
                                        , owns: owns
                                    });
                                    numPushed++;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Strip out any expected assmts from the working return array if the Inventory Only switch is on
        // and the type is not equal to 0.
        if (inventoryOnly === true) {
            const tempRet = [];
            for (let i = 0; i < ret.length; ++i) {
                if (ret[i].type === 0) {
                    tempRet.push(ret[i]);
                }
            }
            ret = tempRet;
        }

        switch (config.rightJustificationProfile) {
            // case 0:
            //     break;
            case 1:
                if (ret.length > 0) {
                    const last = ret[ret.length - 1];
                    // If the type of the last assmt is >=0, it means it's either an actual
                    // or a late assessment, but specifically, it means it's not an upcoming
                    // assessment.  For Riverside, we only want upcoming in the last position.
                    // So, if the last is not an upcoming, push a null onto the end of
                    // the array to push everything back one.
                    if (last.type >= 0) {
                        ret.push(null);
                    } else {
                        // Otherwise, the last assessment is an upcoming.  This should always
                        // be in the left-handmost column, and so should be the 4th element.
                        // But the assessments coming before should be 1, 2, 3.  And so if
                        // there are fewer than 4 total assmts, push null in between the last
                        // and first few to push the first few back.
                        while (ret.length < 4) {
                            ret.splice(ret.length - 1, 0, null);
                        }
                    }
                }
                break;
            case 2:
                if (ret.length > 0) {
                    const last = ret[ret.length - 1];
                    // If the type of the last assmt is >=0, it means it's either an actual
                    // or a late assessment, but specifically, it means it's not an upcoming
                    // assessment.  For Alameda, we only want upcoming in the last position.
                    // So, if the last is not an upcoming, push a null onto the end of
                    // the array to push everything back one.
                    if (last.type >= 0) {
                        ret.push(null);
                    }
                }

                // Pad 4 blanks onto the beginning, so as always to get at least a four-length array.
                ret.splice(0, 0, null);
                ret.splice(0, 0, null);
                ret.splice(0, 0, null);
                ret.splice(0, 0, null);
                break;
            default:
                // Or case 0.
                break;
        }
        if (ret.length > 4) {
            return ret.slice(-4);
        }

        return ret;
    }

    // Get the last 4 expected reassessment dates based on Rolling expected due dates.
    getRollingAssessmentsIntervalsCommon(epOpening, epClosing, reassessmentFrequency, actuals, initial, config) {
        let startDate = (initial != null && initial.date != null) ? new Date(initial.date) : new Date(epOpening);
        const endDate = epClosing != null ? new Date(epClosing) : new Date();
        const ret = [];
        const reassessmentIncrement = (reassessmentFrequency != null ? reassessmentFrequency : config.globalReassessmentFrequency) / 30;

        let actualPos = 0;

        while (startDate <= endDate) {
            let interval = null;
            if (startDate.getMonth() + reassessmentIncrement > 11) {
                startDate.setFullYear(startDate.getFullYear() + 1);
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement - 12));
            } else {
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement));
            }

            // Check if we need to restart the expected day computation from the last actual assessment
            if (actuals != null && actuals.length > 0 && actualPos < actuals.length) {
                for (let i = actualPos; i < actuals.length; i++) {
                    if (actuals[i].date < interval) {
                        startDate = new Date(actuals[i].date);
                        if (startDate.getMonth() + reassessmentIncrement > 11) {
                            startDate.setFullYear(startDate.getFullYear() + 1);
                            interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement - 12));
                        } else {
                            interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement));
                        }

                        actualPos = i + 1;
                    }
                }
            }

            if (epClosing == null || (epClosing != null && interval <= epClosing)) {
                ret.push({date: interval, discharge: false});
            }
        }

        return ret;
    }

    // Alameda
    getFixedAssessmentsIntervalsCommon1(epOpening, epClosing, reassessmentFrequency, actuals, initial, config) {
        const startDate = new Date(epOpening);
        const endDate = epClosing != null ? new Date(epClosing) : new Date();
        const ret = [];
        const reassessmentIncrement = (reassessmentFrequency != null ? reassessmentFrequency : config.globalReassessmentFrequency) / 30;

        const actualPos = 0;

        startDate.setDate(1);

        while (startDate <= endDate) {
            let interval = null;
            if (startDate.getMonth() + reassessmentIncrement > 11) {
                startDate.setFullYear(startDate.getFullYear() + 1);
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement - 12));
            } else {
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement));
            }

            // Subtract a day.
            interval.setDate(interval.getDate() - 1);

            if (epClosing == null || (epClosing != null && interval <= epClosing)) {
                ret.push({date: interval, discharge: false});
            }
        }

        return ret;
    }

    // Victor Exception OUs.
    getFixedAssessmentsIntervalsCommon2(epOpening, epClosing, reassessmentFrequency, actuals, initial, config) {
        let startDate;
        const endDate = epClosing != null ? new Date(epClosing) : new Date();
        const ret = [];
        const reassessmentIncrement = (reassessmentFrequency != null ? reassessmentFrequency : config.globalReassessmentFrequency) / 30;

        // Use the Initial assessment as the starting date.  But only use the date
        // from the Initial if it is an actual assessment.  It will have 'type' of 0
        // in this case.  For all other instances where Initial may be overdue or
        // upcoming, use the EpOpening date as the starting date.
        if (initial.date != null && initial.date !== 'null' && initial.type === 0) {
            startDate = new Date(initial.date);
        } else {
            startDate = new Date(epOpening);
        }

        const actualPos = 0;

        while (startDate <= endDate) {
            let interval = null;
            if (startDate.getMonth() + reassessmentIncrement > 11) {
                startDate.setFullYear(startDate.getFullYear() + 1);
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement - 12));
            } else {
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement));
            }

            interval.setDate(interval.getDate() - 1);

            if (epClosing == null || (epClosing != null && interval <= epClosing)) {
                ret.push({date: interval, discharge: false});
            }
        }

        return ret;
    }

    // ContraCosta
    getFixedAssessmentsIntervalsCommon3(epOpening, epClosing, reassessmentFrequency, actuals, initial, config) {
        let startDate;
        const endDate = epClosing != null ? new Date(epClosing) : new Date();
        const ret = [];
        const reassessmentIncrement = (reassessmentFrequency != null ? reassessmentFrequency : config.globalReassessmentFrequency) / 30;

        startDate = new Date(epOpening);

        const actualPos = 0;

        while (startDate <= endDate) {
            let interval = null;
            if (startDate.getMonth() + reassessmentIncrement > 11) {
                startDate.setFullYear(startDate.getFullYear() + 1);
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement - 12));
            } else {
                interval = new Date(startDate.setMonth(startDate.getMonth() + reassessmentIncrement));
            }

            if (epClosing == null || (epClosing != null && interval <= epClosing)) {
                ret.push({date: interval, discharge: false});
            }
        }

        return ret;
    }
}
